import { observer } from "mobx-react-lite";
import React, { useContext } from "react";

import { ApiContext } from "../contexts";
import { LandType, SortMethod } from "../types";
import EllipsisLoader from "./EllipsisLoader";
import Select from "./Select";

const SearchResultsBar = observer((props: { 
  landType: LandType;
  onChangeSort?: () => void;
}) => {
  const apiContext = useContext(ApiContext);
  const setSortMethod = (val: SortMethod) => {
    if(props.onChangeSort){
      props.onChangeSort();
    }
    apiContext.setSortMethod(val);
  };

  return (
    <div
      className={`pyht-search-results-bar loader-container ${
        apiContext.isLoading && !apiContext.isLoadingNextPage ? "loading" : ""
      }`}
    >
      {apiContext.isLoading && !apiContext.isLoadingNextPage && (
        <EllipsisLoader />
      )}
      {props.landType === LandType.HOUSE_LAND_PACKAGE ? (
        <p className={"section-label results-count"}>
          {apiContext.houseLandSearchResults.length} Packages Match Your
          Criteria
        </p>
      ) : (
        <p className={"section-label results-count"}>
          {apiContext.homeSearchTotalResults} Homes Match Your Criteria
        </p>
      )}

      <div className={"sort-container"}>
        <p className={"section-label"}>Sort By:</p>
        <Select
          id={"home-sort-by"}
          options={[
            {
              key: SortMethod.POPULARITY,
              value: "Popularity",
            },
            {
              key: SortMethod.PRICE_ASC,
              value: "Price: Lowest to Highest",
            },
            {
              key: SortMethod.PRICE_DESC,
              value: "Price: Highest to Lowest",
            },
            {
              key: SortMethod.SIZE_ASC,
              value: "Home Size: Smallest to Largest",
            },
            {
              key: SortMethod.SIZE_DESC,
              value: "Home Size: Largest to Smallest",
            },
          ]}
          value={apiContext.sortMethod}
          onChange={(val) => setSortMethod(val as SortMethod)}
        />
      </div>
    </div>
  );
});

export default SearchResultsBar;
